import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from '@/App.vue';
import { i18n } from '@/locales';
import router from '@/router';
import { useUserStore } from '@/stores/user';
import '@/assets/main.css';

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);

app.use(i18n);
app.use(router);

const userStore = useUserStore();
userStore
	.initialize()
	.catch(err => console.error('[OIDC] Initialization failed:', err))
	.finally(() => app.mount('#app'));
